import { Component, OnInit, OnDestroy, ViewChild, Renderer2, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { forkJoin, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';

import { MasterConstants } from '../../../common/constants/master-constants';
import { CppSraCostSheetService } from '../../../services/cpp-sra-cost-sheet/cpp-sra-cost-sheet.service';
import { CppSRACostSheetGlossarySliderModelService } from '../cpp-sra-cost-sheet-glossary/cpp-sra-cost-sheet-glossary-slider-model.service';
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { RowSpanComputer, Span } from '../../../services/common/row-span-computer';
import { CppPriceListService } from './../../../services/cpp/cpp-price-list.service';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { LolLoggerService } from '../../../common/shared/lol-logger.service';
import { MatDialog } from '@angular/material/dialog';
import { UserReportFilterSliderService } from '../../../common/components/user-report-filter/user-report-filter-slider.service';
import { UserFilterColumnDisplayed } from '../../../models/user-filter-columndisplayed.model';
import { ColumnDescription, UserReportFilter } from '../../../models/user-report-filter.model';
import { UserReportFilterService } from '../../../services/seed/reports/user-report-filter.service';
import { ReportType } from '../../../models/report-type.model';
import { Router } from '@angular/router';
import { CommonService } from '../../../services/common/common.service';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-cpp-sra-cost-sheet-retail',
  templateUrl: './cpp-sra-cost-sheet-retail.component.html',
  styleUrls: ['./cpp-sra-cost-sheet-retail.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: 0, display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('500ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(400, style({ height: '0px', opacity: 1 }))
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(200, style({ height: '0px', opacity: 0 }))
      ])
    ])
  ],
  encapsulation: ViewEncapsulation.None
})
export class CppSraCostSheetRetailComponent implements OnInit, OnDestroy {
  @ViewChild('costSheetPaginator', { read: MatPaginator }) costSheetPaginator: MatPaginator;
  @ViewChild('costSheetSummaryPaginator', { read: MatPaginator }) costSheetSummaryPaginator: MatPaginator;

  subscription = new Subscription();
  private subscriptionArray = new Array<Subscription>();
  masterConstants = MasterConstants;
  productsList = [];
  productsDescriptionList = [];
  supplierList = [];
  customerList = [];
  productLineList = [];
  productCategoryList = [];
  changeSinceDate: any;
  datasourceModal: string;
  filterValueList = new Array();
  yesNoList = [
    { id: 'Y', value: 'Yes' },
    { id: 'N', value: 'No' }
  ];
  DataSourceList = [
    { id: 'SRA', value: 'Historical List' },
    { id: 'NPL', value: 'National Price List' },
    { id: 'DIL', value: 'Discontinued Item List' },
    { id: 'FAV', value: 'My Favorite Items' },
    { id: 'NP', value: 'New Products' }
  ];
  sinceDate: any;
  isOwnerPriceListAccess = 'N';
  isSraCostSheetAccess = 'N';
  isSraCostSheetSummaryAccess = 'N';
  hasSraCostSheetTemplate: boolean = false;
  hasSraCostSheetSummaryTemplate: boolean = false;

  currentTab = 0;
  selectedTabLebal = "1";
  selectedTabIndex = 0;
  columnSelection: any = {
    manufacturerSurcharge: true,
    distributionCost: true,
    retailStockingRebate: true,
    retailUnpublishedRebates: true,
    retailLocalRebate: true
  };
  excludeSraColumn: string[] = ['customerNumber', 'customerName', 'itemDescription'];

  private originalDisplayedColumns : Array<ColumnDescription> = []
  private originalDisplayedCostSheetColumns: Array<ColumnDescription> = [];

  public currentSraFilter = new UserReportFilter();
  public currentSummaryFilter = new UserReportFilter();
  columnNames: string[]; 

  columnName = ['customerNumber', 'customerName'];
  group1Cols = ['wholesaleRebatePcguidance', 'srarebatePcguidance', 'distributorList', 'manufacturerSurcharge', 'distributionCost', 'lowNetwoPrepay']
  group2Cols = ['nationalPrice', 'competitiveAllowancePc', 'specialPricePc', 'manufacturerSurcharge', 'lowNetwoPrepay']
  group3Cols = ['contractPrepayPc', 'lowNetwoPrepay', 'lowNetwPrepay']
  columnInvolvement = {
    wholesaleRebatePcguidance: this.group1Cols,
    distributorList: this.group1Cols,
    srarebatePcguidance: this.group1Cols,
    distributionCost: this.group1Cols,
    nationalPrice: this.group2Cols,
    competitiveAllowancePc: this.group2Cols,
    specialPricePc: this.group2Cols,
    contractPrepayPc: this.group3Cols,
    lowNetwPrepay: this.group3Cols
  };
  coloumnToAddHeaderCss = {
    'wholesaleRebatePcguidance': false,
    'srarebatePcguidance': false,
    'distributorList': false,
    'manufacturerSurcharge': false,
    'distributionCost': false,
    'lowNetwoPrepay': false,
    'nationalPrice': false,
    'competitiveAllowancePc': false,
    'manufacturerSurchargePc': false,
    'specialPricePc': false,
    'lowNetwPrepay': false,
    'contractPrepayPc': false
  };
  costSheetDataList: any = [];
  costSheetDataSource = new MatTableDataSource();
  rowSpans: Array<Span[]>;
  private rowSpanComputer = new RowSpanComputer();

  costSheetSummaryGroupColumnNames = ['customerNumber', 'customerName'];
  costSheetSummaryColumnNames: string[] = this.originalDisplayedCostSheetColumns.map(x => x.columnfield);
  costSheetSummaryDataList: any = [];
  costSheetSummaryDataSource = new MatTableDataSource();
  summaryRowSpans: Array<Span[]>;
  oldFilters: any;
  hasOldFilter: boolean = false;
  filters: any = {
    products: null,
    productsDescription: null,
    suppliers: null,
    customers: null,
    productLines: null,
    productCategories: null,
    changeSinceDate: null,
    vendedHIF: null,
    prepayEligible: null,
    currentTabIndex: null,
    isExport: null,
    dataSource: null,
    priceChangeIndicator: null,
    displayedColumns: []
  };
  sraFilters: any;
  summaryFilters: any;
  sraExportFilters: any = Object.assign({}, this.filters);
  editToolKit = false;
  selectedCount = 0;
  selectedCountSummary = 0;
  disablecheckbox: any;
  allChecked = false;
  isExpanded = true;
  currentDate = new Date();
  productsCount: number = 0;
  constructor(private cppSRACostSheetGlossarySliderModelService: CppSRACostSheetGlossarySliderModelService,
    private cppSraCostSheetService: CppSraCostSheetService,
    private cppPriceListService: CppPriceListService,
    private userReportFilterSliderService: UserReportFilterSliderService,
    private userReportFilterService: UserReportFilterService,
    private toastrService: ToastrService,
    private datePipe: DatePipe,
    private commonService: CommonService,
    private loaderService: LoaderService, private renderer: Renderer2, private matDialog: MatDialog,
    private router: Router) {
    this.renderer.listen('window', 'click', (e: Event) => {
      // to remove grouping on click anywhere
      this.resetGroupingColorFilters();
    });
  }

  ngOnInit(): void {
    this.fetchFiltersData();
    this.disablecheckbox = true;

    this.subscriptionArray.push(
      this.userReportFilterSliderService.selectedUserFilter.subscribe(filter => {
        if (filter && filter.reportFilter) {
          const filters: UserFilterColumnDisplayed = JSON.parse(filter.reportFilter);
          if (filter.reportTypeId === ReportType.SraCostSheetReport) {
            this.currentSraFilter = filter;
            this.columnNames = [];
            this.columnNames.push('customerNumber', 'customerName', 'itemDescription'); //Fixed column for Grid
            filters.displayedColumns.forEach(x => {
              this.columnNames.push(x.columnfield);
            });
            this.filters = filters.filterOption;
            this.sraFilters = filters.filterOption;
          }
          else if (filter.reportTypeId === ReportType.SraWuDeliveredCostReport) {
            this.currentSummaryFilter = filter;
            this.costSheetSummaryColumnNames = [];
            this.costSheetSummaryColumnNames.push('customerNumber', 'customerName', 'itemDescription'); //Fixed column for Grid
            filters.displayedColumns.forEach(x => {
              this.costSheetSummaryColumnNames.push(x.columnfield);
            });
            this.filters = filters.filterOption;
            this.summaryFilters = filters.filterOption;
          }
          else {
            this.currentSraFilter = new UserReportFilter();
            this.currentSummaryFilter = new UserReportFilter();
          }
        }
        else {
          if ((filter && filter.reportTypeId === ReportType.SraCostSheetReport
            && filter.filterDescription === this.currentSraFilter.filterDescription)
            || (!filter && this.selectedTabIndex === 0)) {
            this.columnNames = this.originalDisplayedColumns.map(x => x.columnfield);
            this.currentSraFilter = new UserReportFilter();
          }
          else if (filter && filter.reportTypeId === ReportType.SraWuDeliveredCostReport
            && filter.filterDescription === this.currentSummaryFilter.filterDescription
            || (!filter && this.selectedTabIndex === 1)) {
            this.costSheetSummaryColumnNames = this.originalDisplayedCostSheetColumns.map(x => x.columnfield);
            this.currentSummaryFilter = new UserReportFilter();
          }
        }
      }));
  }
  resetGroupingColorFilters() {
    for (const key of Object.keys(this.coloumnToAddHeaderCss)) {
      this.coloumnToAddHeaderCss[key] = false;
    }
  }

  // Toggle Pickup Section
  togglePickup() {
    this.isExpanded = !this.isExpanded;
  }

  getToolTipValue(key: string) {
    switch (key) {
      case 'distributorList':
        return 'Similar to redemption price';
      case 'wholesaleRebatePcguidance':
        return 'Static wholesale rebate by product through crop year';
      case 'sraRebatePCGuidance':
        return 'Static SRA retail rebate by product through \n crop year';
      case 'distributionCost':
        return 'WU distribution cost, transparent with \n vended cost pricing';
      case 'wuDeliveredCost':
        return 'Vended cost pricing is distributor list pricing less wholesale guidance rates, plus WU distribution and mfg surcharges';
      case 'prepayEligible':
        return 'Determines if current prepay contract by \n account & product';
      case 'contractPrepayPc':
        return 'Displays contracted prepay % by account';
      case 'lowNetwPrepay':
        return 'Discounts contracted prepay amount from \n low net price';
      case 'currentAprpc':
        return 'Current month\'s APR rate';
      case 'decAprpc':
        return 'December APR rate for current crop year';
      case 'juneAprpc':
        return 'June APR rate for current crop year';
    }
  }

  getToolTipValue4Summary(key: string) {
    switch (key) {
      case 'wuDeliveredCost':
        return 'Vended cost pricing is distributor list pricing less wholesale guidance rates, plus WU distribution and mfg surcharges';
      case 'contractPrepayPc':
        return 'Displays contracted prepay % by account';
    }
  }

  findColumninvolment(columnKey: string) {
    LolLoggerService.info(columnKey);
    const cols = this.columnInvolvement[columnKey];
    const toBeFalse = this.columnNames.filter(val => !cols.includes(val));
    if (toBeFalse.length > 0) {
      toBeFalse.map((x) => this.coloumnToAddHeaderCss[x] = false);
    }
    if (cols.length > 0) {
      this.coloumnToAddHeaderCss[columnKey] = true;
      cols.map((x) => {
        this.coloumnToAddHeaderCss[x] = true;
      });
    }
  }

  fetchFiltersData() {
    this.cppSraCostSheetService.isSraCostSheetAccess = this.isSraCostSheetAccess;
    this.loaderService.setLoaderStatus(true);
    const forkJoinApIs = [];
    forkJoinApIs.push(this.cppSraCostSheetService.getFilterList());
    //forkJoinApIs.push(this.cppSraCostSheetService.getSinceDateData());
    forkJoinApIs.push(this.cppPriceListService.ownerPriceListAccessPermission(0));
    this.subscription.add(forkJoin(forkJoinApIs).subscribe((result: any[]) => {
      if (result[0]) {
        this.productsDescriptionList = result[0].products;
        this.productsList = result[0].products;
        this.supplierList = result[0].suppliers;
        this.customerList = result[0].customers;
        this.productLineList = result[0].productLines;
        this.productCategoryList = result[0].productCategories;
        this.hasSraCostSheetTemplate = result[0].hasCostSheetTemplate;
        this.hasSraCostSheetSummaryTemplate = result[0].hasCostSheetSummaryTemplate;
        this.productsCount = result[0].productsCount;

        //set change since date to 30 days older
        this.filters.changeSinceDate = new Date();
        this.filters.changeSinceDate.setDate(this.currentDate.getDate() - 30);
        this.changeSinceDate = this.filters.changeSinceDate;
        this.originalDisplayedColumns = result[0].costSheetColumnDescriptions;
        this.originalDisplayedCostSheetColumns = result[0].costSheetSummaryColumnDescriptions;
        this.columnNames = this.originalDisplayedColumns.map(x => x.columnfield);
        this.costSheetSummaryColumnNames = this.originalDisplayedCostSheetColumns.map(x => x.columnfield);
      }

      //if (result[1]) {
      //  this.filters.changeSinceDate = result[1];
      //}

      if (result[1]) {
        this.isOwnerPriceListAccess = result[1].data[0];
        this.isSraCostSheetAccess = result[1].data[1];
        this.isSraCostSheetSummaryAccess = result[1].data[2];
      }

      this.loaderService.setLoaderStatus(false);
    }, () => {
      this.loaderService.setLoaderStatus(false);
    }, () => {
      this.oldFilters = this.cppSraCostSheetService.getOldFilters();
      this.hasOldFilter = this.oldFilters != undefined || this.oldFilters != null;
      // Set Filters Values
      this.filters['products'] = this.hasOldFilter ? this.oldFilters['products'] : this.productsList.map(y => y.id).toString();
      this.filters['productsDescription'] = this.hasOldFilter ? this.oldFilters['productsDescription'] : this.productsDescriptionList.map(y => y.id).toString();
      this.filters['suppliers'] = this.hasOldFilter ? this.oldFilters['suppliers'] : this.supplierList.map(y => y.id).toString();
      this.filters['customers'] = this.hasOldFilter ? this.oldFilters['customers'] : this.customerList.map(y => y.accountNumber).toString();
      this.filters['productLines'] = this.hasOldFilter ? this.oldFilters['productLines'] : this.productLineList.map(y => y.id).toString();
      this.filters['productCategories'] = this.hasOldFilter ? this.oldFilters['productCategories'] : this.productCategoryList.map(y => y.id).toString();
      this.filters['vendedHIF'] = this.hasOldFilter ? this.oldFilters['vendedHIF'] : this.yesNoList.map(y => y.id).toString();
      this.filters['prepayEligible'] = this.hasOldFilter ? this.oldFilters['prepayEligible'] : this.yesNoList.map(y => y.id).toString();
      this.filters['changeSinceDate'] = this.hasOldFilter ? this.oldFilters['changeSinceDate'] : this.filters['changeSinceDate'];

      this.filters['dataSource'] = this.hasOldFilter ? this.oldFilters['dataSource'] : this.DataSourceList.map(y => y.id).toString();
      this.filters['priceChangeIndicator'] = this.hasOldFilter ? this.oldFilters['priceChangeIndicator'] : false;
      // set columns Exclusion flags for calculations
      this.columnSelection.manufacturerSurcharge = this.hasOldFilter ? this.oldFilters.manufacturerSurcharge : true;
      this.columnSelection.distributionCost = this.hasOldFilter ? this.oldFilters.distributionCost : true;
      this.columnSelection.retailStockingRebate = this.hasOldFilter ? this.oldFilters.retailStockingRebate : true;
      this.columnSelection.retailUnpublishedRebates = this.hasOldFilter ? this.oldFilters.retailUnpublishedRebates : true;
      this.columnSelection.retailLocalRebate = this.hasOldFilter ? this.oldFilters.retailLocalRebate : true;
      this.sraFilters = Object.assign({}, this.filters);
      this.summaryFilters = Object.assign({}, this.filters);
      this.cppSraCostSheetService.setOldFilters(null);
      //get grid data if comes from simulation screen
      if (this.hasOldFilter) {
        this.GetGridData();
      }
      else {
        this.getSraToggleColumnData();
      }
    }
    ));
  }

  navigatePriceSimulation() {
    this.sraExportFilters.simulationDisplayedColumns = this.originalDisplayedColumns.filter(x => x.columnfield != 'lowNetwoPrepayPriceChange');
    this.cppSraCostSheetService.setOldFilters(this.sraExportFilters);
    this.cppSraCostSheetService.isSraCostSheetAccess = this.isSraCostSheetAccess;
    this.router.navigate(['/cpp/sra-cost-sheet-price-simulation']);
  }

  getSraToggleColumnData() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.cppSraCostSheetService.getToggleSettings("CostSheet").subscribe(result => {
      if (result) {
        result.ToggleColumns.forEach(obj => {
          let column = obj.ColumnName;
          switch (column) {
            case 'manufacturerSurcharge':
              this.columnSelection.manufacturerSurcharge = obj.IsChecked;
              break;
            case 'distributionCost':
              this.columnSelection.distributionCost = obj.IsChecked;
              break;
            case 'retailStockingRebate':
              this.columnSelection.retailStockingRebate = obj.IsChecked;
              break;
            case 'retailUnpublishedRebates':
              this.columnSelection.retailUnpublishedRebates = obj.IsChecked;
              break;
            case 'retailLocalRebate':
              this.columnSelection.retailLocalRebate = obj.IsChecked;
              break;
          }
        });
      }
      this.loaderService.setLoaderStatus(false);
    }, () => { this.loaderService.setLoaderStatus(false); }));
  }

  saveSraToggleColumnSettings() {
    this.loaderService.setLoaderStatus(true);
    const toggleList = [
      { columnName: 'manufacturerSurcharge', isChecked: this.columnSelection.manufacturerSurcharge },
      { columnName: 'distributionCost', isChecked: this.columnSelection.distributionCost },
      { columnName: 'retailStockingRebate', isChecked: this.columnSelection.retailStockingRebate },
      { columnName: 'retailUnpublishedRebates', isChecked: this.columnSelection.retailUnpublishedRebates },
      { columnName: 'retailLocalRebate', isChecked: this.columnSelection.retailLocalRebate }
    ];
    const filter = {
      toggleColumns: toggleList,
      tabName: "CostSheet"
    };
    this.subscription.add(this.cppSraCostSheetService.saveToggleSettings(filter).subscribe(result => {
      if (result) {
        this.toastrService.success('Toggle Preferences Settings saved successfully.');
      }
      else {
        this.toastrService.success('Toggle Preferences Settings not saved in the system.');
      }
      this.loaderService.setLoaderStatus(false);
    }, () => { this.loaderService.setLoaderStatus(false); }));
  }

  GetGridData() {
    this.editToolKit = false;
    this.selectedCount = 0;
    this.selectedCountSummary = 0;
    this.allChecked = false;
    this.loaderService.setLoaderStatus(true);
    const forkJoinApIs = [];

    // set columns Exclusion flags for calculations
    this.filters.manufacturerSurcharge = this.columnSelection.manufacturerSurcharge;
    this.filters.distributionCost = this.columnSelection.distributionCost;
    this.filters.retailStockingRebate = this.columnSelection.retailStockingRebate;
    this.filters.retailUnpublishedRebates = this.columnSelection.retailUnpublishedRebates;
    this.filters.retailLocalRebate = this.columnSelection.retailLocalRebate;
    this.filters.productsCount = this.productsCount;

    this.sraExportFilters = Object.assign({}, this.filters);
    forkJoinApIs.push(this.cppSraCostSheetService.getSRAGridData(this.filters));
    this.subscription.add(forkJoin(forkJoinApIs).subscribe((result: any[]) => {
      if (result[0]) {
        if (this.isSraCostSheetAccess === 'Y' && result[0].costSheet) {
          this.costSheetDataList = result[0].costSheet;
          this.costSheetDataList.forEach((obj) => {
            obj.isSelected = false;
          });
          this.costSheetDataSource = new MatTableDataSource(this.costSheetDataList);
          this.costSheetDataSource.paginator = this.costSheetPaginator;
          this.costSheetDataSource.paginator.firstPage();
          this.rowSpans = this.rowSpanComputer.compute(this.costSheetDataList, this.columnName, this.columnNames);
        }

        if (this.isSraCostSheetSummaryAccess === 'Y' && result[0].costSheetSummary) {
          this.costSheetSummaryDataList = result[0].costSheetSummary;
          this.costSheetSummaryDataList.forEach((obj) => {
            obj.isSelected = false;
          });
          this.costSheetSummaryDataSource = new MatTableDataSource(this.costSheetSummaryDataList);
          this.costSheetSummaryDataSource.paginator = this.costSheetSummaryPaginator;
          this.costSheetSummaryDataSource.paginator.firstPage();
          this.summaryRowSpans = this.rowSpanComputer.compute(this.costSheetSummaryDataList, this.costSheetSummaryGroupColumnNames, this.costSheetSummaryColumnNames);
        }
      }
      if (result[0].length > 0) {
        this.disablecheckbox = true;
      }
      else {
        this.disablecheckbox = false;
      }

      this.loaderService.setLoaderStatus(false);
    }, () => this.loaderService.setLoaderStatus(false)));
  }

  changeFilter = (event, key) => {
    if (key === 'changeSinceDate') {
      const changeSinceDate = event.value;
      this.filters[key] = new Date(changeSinceDate.getFullYear(), changeSinceDate.getMonth(), changeSinceDate.getDate(), changeSinceDate.getHours(), changeSinceDate.getMinutes() - changeSinceDate.getTimezoneOffset()).toISOString();
    }
    else if (key === 'priceChangeIndicator') {
      this.filters[key] = event.checked;
    }
    else if (key === 'productsDescription' || key === 'products') {
      this.filters['products'] = event instanceof Event ? this.filters[key] : event.join(',');
      this.filters['productsDescription'] = event instanceof Event ? this.filters[key] : event.join(',');

    }
    else {
      this.filters[key] = event instanceof Event ? this.filters[key] : event.join(',');
    }
  };

  showGlossary() {
    this.cppSRACostSheetGlossarySliderModelService.activeSlider('ShowSRACostSheetGlossary');
  }

  amountValue(val): string {
    return '$' + `${!val ? '0.00' : val.toFixed(2)}`;
  }

  percentValue(val): string {
    return `${!val ? '0.00' : val.toFixed(2)}` + '%';
  }

  roundValue(val): string {
    return `${!val ? '0.00' : val.toFixed(2)}`;
  }

  columnCheckboxSelection(key: string, event: any) {
    this.columnSelection[key] = event.checked;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscriptionArray.forEach(subscription => subscription.unsubscribe());
    this.userReportFilterSliderService.resetFilter();
  }

  // Tab changed
  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    if (this.selectedTabIndex === 0 && this.selectedTabIndex !== tabChangeEvent.index) {
      this.sraFilters = this.filters;
      this.filters = this.summaryFilters;
    }
    else if (this.selectedTabIndex === 1 && this.selectedTabIndex !== tabChangeEvent.index) {
      this.summaryFilters = this.filters;
      this.filters = this.sraFilters;
    }
    this.selectedTabIndex = tabChangeEvent.index;
    this.selectedTabLebal = tabChangeEvent.tab.textLabel;
    this.editToolKit = false;
    this.selectedCount = 0;
    this.selectedCountSummary = 0;
    this.allChecked = false;
    this.costSheetDataList.forEach((obj) => {
      obj.isSelected = false;
    });
    this.costSheetSummaryDataList.forEach((obj) => {
      obj.isSelected = false;
    });
  };

  exportData() {
    this.loaderService.setLoaderStatus(true);

    //if there is no access for first tab set current tab index 1
    this.sraExportFilters.currentTabIndex = this.selectedTabIndex === 0 ? (this.isSraCostSheetAccess == 'N' ? '1' : '0') : '1';
    this.sraExportFilters.isExport = true;
    if ((this.isSraCostSheetAccess == 'Y' && this.costSheetDataList && this.costSheetDataList.length == 0) ||
      (this.isSraCostSheetSummaryAccess == 'Y' && this.costSheetSummaryDataList && this.costSheetSummaryDataList.length == 0)) {
      this.sraExportFilters.isExport = false;
    }
    if (this.sraExportFilters.currentTabIndex == '0') {
      this.sraExportFilters.displayedColumns = this.columnNames.map(x => this.originalDisplayedColumns.find(y => y.columnfield === x).headertxt);
    }
    else {
      this.sraExportFilters.displayedColumns = this.costSheetSummaryColumnNames.map(x => this.originalDisplayedCostSheetColumns.find(y => y.columnfield === x).headertxt);
    }

    this.subscription.add(this.cppSraCostSheetService.getSRAGridTabDataExport(this.sraExportFilters).subscribe(result => {
      this.cppSraCostSheetService.base64toFile(result.base64, result.mimeType, result.fileName);
      this.sraExportFilters.isExport = false;
      this.loaderService.setLoaderStatus(false);
    }, () => { this.loaderService.setLoaderStatus(false); }));
  }

  downloadTemplate(templateTypeId) {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.cppSraCostSheetService.getSRAExcelTemplate(templateTypeId).subscribe(result => {
      this.cppSraCostSheetService.base64toFile(result.base64, result.mimeType, result.fileName);
      this.loaderService.setLoaderStatus(false);
    }, () => { this.loaderService.setLoaderStatus(false); }));
  }

  // Enable/Disable single checkbox in each row of the table
  enableCheckBoxSingle(isChecked) {
    if (isChecked) {
      if (this.selectedTabIndex == 1) {
        this.selectedCountSummary = this.selectedCountSummary + 1;
        const checked = this.costSheetSummaryDataList.filter(x => x.isSelected == false);
        if (checked && checked.length == 0) {
          this.allChecked = true;
        }
        else {
          this.allChecked = false;
        }
      }
      else {
        this.selectedCount = this.selectedCount + 1;
        const checked = this.costSheetDataList.filter(x => x.isSelected == false);
        if (checked && checked.length == 0) {
          this.allChecked = true;
        }
        else {
          this.allChecked = false;
        }
      }
    }
    else {
      if (this.selectedTabIndex == 1) {
        this.selectedCountSummary = this.selectedCountSummary - 1;
        this.allChecked = false;
      } else {
        this.selectedCount = this.selectedCount - 1;
        this.allChecked = false;
      }
    }
    if (this.selectedTabIndex == 1) {
      const checked = this.costSheetSummaryDataList.filter(x => x.isSelected === true);
      if (checked) {
        this.editToolKit = (checked.length > 0);
      }
    } else {
      const checked = this.costSheetDataList.filter(x => x.isSelected === true);
      if (checked) {
        this.editToolKit = (checked.length > 0);
      }
    }
  }

  // Enable/Disable checkbox on top of the table for all rows
  enableAllCheckBoxes(isChecked) {
    if (isChecked) {
      if (this.selectedTabIndex == 1) {
        this.costSheetSummaryDataList.forEach(x => {
          x.isSelected = true;
        });
        this.selectedCountSummary = this.costSheetSummaryDataList.length;
      } else {
        this.costSheetDataList.forEach(x => {
          x.isSelected = true;
        });
        this.selectedCount = this.costSheetDataList.length;
      }
    }
    else {
      if (this.selectedTabIndex == 1) {
        this.costSheetSummaryDataList.forEach(x => {
          x.isSelected = false;
        });
        this.selectedCountSummary = 0;
      } else {
        this.costSheetDataList.forEach(x => {
          x.isSelected = false;
        });
        this.selectedCount = 0;
      }
    }
    if (this.selectedTabIndex == 1) {
      const checked = this.costSheetSummaryDataList.filter(x => x.isSelected === true);
      if (checked) {
        this.editToolKit = (checked.length > 0);
      }
    } else {
      const checked = this.costSheetDataList.filter(x => x.isSelected === true);
      if (checked) {
        this.editToolKit = (checked.length > 0);
      }
    }
  }

  //Add or Remove Favorite Items
  AddRemoveGlobalFavorite(value: boolean) {
    let ItemIds: any = [];
    let favoriteFilter: any;
    if (this.selectedTabIndex == 1) {
      this.costSheetSummaryDataList.filter(x => x.isSelected === true).forEach(x => {
        if (x.itemId !== null) {
          ItemIds.push(x.itemID);
        }
      });
      favoriteFilter = {
        itemIds: ItemIds,
        Active: value
      };
    } else {
      this.costSheetDataList.filter(x => x.isSelected === true).forEach(x => {
        if (x.itemId !== null) {
          ItemIds.push(x.itemID);
        }
      });
      favoriteFilter = {
        itemIds: ItemIds,
        Active: value
      };
    }

    this.loaderService.setLoaderStatus(true);
    this.subscriptionArray.push(this.cppSraCostSheetService.addRemoveItemFavoriteItems(favoriteFilter).subscribe(result => {
      if (result) {
        this.GetGridData();
      } error => {
        this.loaderService.setLoaderStatus(false);
        LolLoggerService.error(error);
      }
    }));
  }

  // on clicking individual star icon
  AddRemoveFavoriteIndividual(element, value: boolean) {
    let ItemIds: any = [];
    ItemIds.push(element.itemID);
    const favoriteFilter = {
      itemIds: ItemIds,
      Active: value
    };

    this.loaderService.setLoaderStatus(true);
    this.subscriptionArray.push(this.cppSraCostSheetService.addRemoveItemFavoriteItems(favoriteFilter).subscribe(result => {
      if (result) {
        this.GetGridData();
      } error => {
        this.loaderService.setLoaderStatus(false);
        LolLoggerService.error(error);
      }
    }));
  }
  // Method for Showing Filter values for create report Page

  convertFiltersToFiltervalueList() {
    this.filterValueList = [];
    if (this.filters) {
      // Products Filter
      if (this.filters.products && this.filters.products != '') {
        let strPS = '';
        let prodouctCount = 0;
        const productSelected = this.filters.products.split(',').map(item => item.trim());
        productSelected.forEach(x => {
          prodouctCount++;
          let productData = this.productsList.find(y => y.id == x);
          if (productData) {
            strPS = strPS + `${productData.id} - ${productData.value}` + ', ';
          }
        });
        if (prodouctCount === this.productsList.length) {
          this.filterValueList.push('WinField United Product : All');
        }
        else {
          this.filterValueList.push('WinField United Product : ' + strPS.substr(0, strPS.length - 2));
        }
      }
      // Vended HIF Filter
      if (this.filters.vendedHIF && this.filters.vendedHIF != '') {
        let strPS = '';
        let vendedHIFCount = 0;
        const vendedHIFSelected = this.filters.vendedHIF.split(',').map(item => item.trim());
        vendedHIFSelected.forEach(x => {
          vendedHIFCount++;
          let vendedHIFData = this.yesNoList.find(y => y.id == x);
          if (vendedHIFData) {
            strPS = strPS + vendedHIFData.value + ', ';
          }
        });
        if (vendedHIFCount === this.yesNoList.length) {
          this.filterValueList.push('Vended HIF : All');
        }
        else {
          this.filterValueList.push('Vended HIF : ' + strPS.substr(0, strPS.length - 2));
        }
      }

      // Supplier Filter
      if (this.filters.suppliers && this.filters.suppliers != '') {
        let strPS = '';
        let suppliersCount = 0;
        const supplierSelected = this.filters.suppliers.split(',').map(item => item.trim());
        supplierSelected.forEach(x => {
          suppliersCount++;
          let supplierData = this.supplierList.find(y => y.id == x);
          if (supplierData) {
            strPS = strPS + supplierData.value + ', ';
          }
        });
        if (suppliersCount === this.supplierList.length) {
          this.filterValueList.push('Supplier : All');
        }
        else {
          this.filterValueList.push('Supplier : ' + strPS.substr(0, strPS.length - 2));
        }
      }


      // Products description  Filter
      if (this.filters.productsDescription && this.filters.productsDescription != '') {
        let strPS = '';
        let prodouctCount = 0;
        const productSelected = this.filters.productsDescription.split(',').map(item => item.trim());
        productSelected.forEach(x => {
          prodouctCount++;
          let productData = this.productsDescriptionList.find(y => y.id == x);
          if (productData) {
            strPS = strPS + `${productData.value}` + ', ';
          }
        });
        if (prodouctCount === this.productsList.length) {
          this.filterValueList.push('Product Description : All');
        }
        else {
          this.filterValueList.push('Product Description : ' + strPS.substr(0, strPS.length - 2));
        }
      }
      // Customer Filter
      if (this.filters.customers && this.filters.customers != '') {
        let strPS = '';
        let customersCount = 0;
        const customersSelected = this.filters.customers.split(',').map(item => item.trim());
        customersSelected.forEach(x => {
          customersCount++;
          let customersData = this.customerList.find(y => y.accountNumber == x);
          if (customersData) {
            strPS = strPS + `${customersData.accountNumber} - ${customersData.accountName}` + ', ';
          }
        });
        if (customersCount === this.customerList.length) {
          this.filterValueList.push('Customer : All');
        }
        else {
          this.filterValueList.push('Customer : ' + strPS.substr(0, strPS.length - 2));
        }
      }

      // Product Line Filter
      if (this.filters.productLines && this.filters.productLines != '') {
        let strPS = '';
        let productLinesCount = 0;
        const productLinesSelected = this.filters.productLines.split(',').map(item => item.trim());
        productLinesSelected.forEach(x => {
          productLinesCount++;
          let productLinesData = this.productLineList.find(y => y.id == x);
          if (productLinesData) {
            strPS = strPS + productLinesData.value + ', ';
          }
        });
        if (productLinesCount === this.productLineList.length) {
          this.filterValueList.push('Product Line : All');
        }
        else {
          this.filterValueList.push('Product Line : ' + strPS.substr(0, strPS.length - 2));
        }
      }

      // Product Category Filter
      if (this.filters.productCategories && this.filters.productCategories != '') {
        let strPS = '';
        let productCategoriesCount = 0;
        const productCategoriesSelected = this.filters.productCategories.split(',').map(item => item.trim());
        productCategoriesSelected.forEach(x => {
          productCategoriesCount++;
          let productCategoriesData = this.productCategoryList.find(y => y.id == x);
          if (productCategoriesData) {
            strPS = strPS + productCategoriesData.value + ', ';
          }
        });
        if (productCategoriesCount === this.productCategoryList.length) {
          this.filterValueList.push('Product Group : All');
        }
        else {
          this.filterValueList.push('Product Group : ' + strPS.substr(0, strPS.length - 2));
        }
      }

      // Data Source Filter
      if (this.filters.dataSource && this.filters.dataSource != '') {
        let strPS = '';
        let dataSourceCount = 0;
        const dataSourceSelected = this.filters.dataSource.split(',').map(item => item.trim());
        dataSourceSelected.forEach(x => {
          dataSourceCount++;
          let dataSourceData = this.DataSourceList.find(y => y.id == x);
          if (dataSourceData) {
            strPS = strPS + dataSourceData.value + ', ';
          }
        });
        if (dataSourceCount === this.DataSourceList.length) {
          this.filterValueList.push('Data Source : All');
        }
        else {
          this.filterValueList.push('Data Source : ' + strPS.substr(0, strPS.length - 2));
        }
      }


      // Prepay Eligible Filter
      if (this.filters.prepayEligible && this.filters.prepayEligible != '') {
        let strPS = '';
        let prepayEligibleCount = 0;
        const prepayEligibleSelected = this.filters.prepayEligible.split(',').map(item => item.trim());
        prepayEligibleSelected.forEach(x => {
          prepayEligibleCount++;
          let prepayEligibleData = this.yesNoList.find(y => y.id == x);
          if (prepayEligibleData) {
            strPS = strPS + prepayEligibleData.value + ', ';
          }
        });
        if (prepayEligibleCount === this.yesNoList.length) {
          this.filterValueList.push('Prepay Eligible : All');
        }
        else {
          this.filterValueList.push('Prepay Eligible : ' + strPS.substr(0, strPS.length - 2));
        }
      }

      // Change Since Date Filter
      if (this.filters.changeSinceDate && this.filters.changeSinceDate != '') {
        this.filterValueList.push('Change Since Date : ' + this.datePipe.transform(this.filters.changeSinceDate.toString(), 'MM/dd/yyyy'));
      }

      // Price change indicator

      this.filterValueList.push('Price Change Indicator : ' + this.filters.priceChangeIndicator);

    }
  }
  //Select filter
  public selectFilter() {
    this.convertFiltersToFiltervalueList();
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.filters,
      filterValueList: this.filterValueList
    };

    let newFilter = new UserReportFilter();

    newFilter.reportFilter = JSON.stringify(filters);
    if (this.selectedTabIndex === 1) {
      var sraColumn = this.originalDisplayedCostSheetColumns.filter(item => !this.excludeSraColumn.includes(item.columnfield)).map(x => new ColumnDescription(x.columnfield, x.headertxt));
      var reportTypeid = ReportType.SraWuDeliveredCostReport;
    }
    else {
      var sraColumn = this.originalDisplayedColumns.filter(item => !this.excludeSraColumn.includes(item.columnfield)).map(x => new ColumnDescription(x.columnfield, x.headertxt));
      var reportTypeid = ReportType.SraCostSheetReport;
    }

    this.userReportFilterSliderService.activeSlider(reportTypeid, 0, sraColumn, newFilter);
  }
  //Add filter
  public addFilter() {
    this.convertFiltersToFiltervalueList();
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.filters,
      filterValueList: this.filterValueList
    };

    let newFilter = new UserReportFilter();

    newFilter.reportFilter = JSON.stringify(filters);
    if (this.selectedTabIndex === 1) {
      var sraColumn = this.originalDisplayedCostSheetColumns.filter(item => !this.excludeSraColumn.includes(item.columnfield)).map(x => new ColumnDescription(x.columnfield, x.headertxt));
      var reportTypeid = ReportType.SraWuDeliveredCostReport;
    }
    else {
      var sraColumn = this.originalDisplayedColumns.filter(item => !this.excludeSraColumn.includes(item.columnfield)).map(x => new ColumnDescription(x.columnfield, x.headertxt));
      var reportTypeid = ReportType.SraCostSheetReport;
    }

    this.userReportFilterSliderService.activeSlider(reportTypeid, 1, sraColumn, newFilter);
  }

  public editFilter() {
    this.convertFiltersToFiltervalueList();
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.filters,
      filterValueList: this.filterValueList,
      displayedColumns: []
    };
    if (this.selectedTabIndex === 1) {
      filters.displayedColumns = this.costSheetSummaryColumnNames.filter(item => !this.excludeSraColumn.includes(item)).map(x => this.originalDisplayedCostSheetColumns.find(y => y.columnfield === x));
      var sraColumn = this.originalDisplayedCostSheetColumns.filter(item => !this.excludeSraColumn.includes(item.columnfield)).map(x => new ColumnDescription(x.columnfield, x.headertxt));
      var reportTypeid = ReportType.SraWuDeliveredCostReport;
      this.currentSummaryFilter.reportFilter = JSON.stringify(filters);
      var curfilter = this.currentSummaryFilter;
    }
    else {
      filters.displayedColumns = this.columnNames.filter(item => !this.excludeSraColumn.includes(item)).map(x => this.originalDisplayedColumns.find(y => y.columnfield === x));
      var sraColumn = this.originalDisplayedColumns.filter(item => !this.excludeSraColumn.includes(item.columnfield)).map(x => new ColumnDescription(x.columnfield, x.headertxt));
      var reportTypeid = ReportType.SraCostSheetReport;
      this.currentSraFilter.reportFilter = JSON.stringify(filters);
      var curfilter = this.currentSraFilter;
    }

    this.userReportFilterSliderService.activeSlider(reportTypeid, 1, sraColumn, curfilter);
  }

  public save(): void {
    this.convertFiltersToFiltervalueList();
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.filters,
      filterValueList: this.filterValueList,
      displayedColumns: []
    };
    if (this.selectedTabIndex === 1) {
      filters.displayedColumns = this.costSheetSummaryColumnNames.filter(item => !this.excludeSraColumn.includes(item)).map(x => this.originalDisplayedCostSheetColumns.find(y => y.columnfield === x));
      this.currentSummaryFilter.reportFilter = JSON.stringify(filters);
      var curfilter = this.currentSummaryFilter;
      var reportFilterId = this.currentSummaryFilter.userReportFilterId;
    }
    else {
      filters.displayedColumns = this.columnNames.filter(item => !this.excludeSraColumn.includes(item)).map(x => this.originalDisplayedColumns.find(y => y.columnfield === x));
      this.currentSraFilter.reportFilter = JSON.stringify(filters);
      var curfilter = this.currentSraFilter;
      var reportFilterId = this.currentSraFilter.userReportFilterId;
    }

    if (reportFilterId) {
      this.subscriptionArray.push(this.userReportFilterService.updateUserReportFilters(curfilter).subscribe(filter => {
        if (filter) {
          this.toastrService.success("Records saved successfully.");
        }
      }));
    }
    else {
      this.subscriptionArray.push(this.userReportFilterService.addUserReportFilters(curfilter).subscribe(filter => {
        if (filter) {
          if (this.selectedTabIndex === 1) {
            this.currentSummaryFilter.userReportFilterId = filter.userReportFilterId;
          }
          else {
            this.currentSraFilter.userReportFilterId = filter.userReportFilterId;
          }
          this.toastrService.success("Records saved successfully.");
        }
      }));
    }
  }
}
